import { State, StateView } from 'components';
import { useConfirmAccount } from 'hooks';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { isEmptyOrNull } from 'utils';

const successMessages = [
  'Prima, dein Konto bleibt erhalten.',
  'Wir freuen uns, dich wiederzusehen!'
];

const errorMessages = ['Ups, etwas ist schiefgelaufen!'];

export const AccountConfirmation: FC = () => {
  const [searchParams] = useSearchParams();

  const personId = searchParams.get('person') ?? undefined;
  const mailToken = searchParams.get('token') ?? undefined;

  const { mutate: confirmAccount } = useConfirmAccount();

  const [state, setState] = useState<State>(State.Loading);
  const [messages, setMessages] = useState<string[]>();

  const handleConfirmAccount = useCallback(() => {
    if (mailToken && personId) {
      confirmAccount(
        {
          mailToken,
          clientPersonResetLastLoggedInRequest: { personId }
        },
        {
          onError: () => {
            setState(State.Error);
            setMessages(errorMessages);
          },
          onSuccess: () => {
            setState(State.Success);
            setMessages(successMessages);
          }
        }
      );
    }
  }, [confirmAccount, mailToken, personId]);

  useEffect(() => {
    if (!isEmptyOrNull(personId) && !isEmptyOrNull(mailToken)) {
      handleConfirmAccount();
    } else {
      setState(State.Error);
      setMessages(errorMessages.concat(['MISSING_OR_INVALID_QUERY_PARAM']));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personId, mailToken]);

  return <StateView state={state} messages={messages} />;
};
